import { useEffect, useState } from 'react';

// material-ui
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

// project import
import NavGroup from './NavGroup';
import * as icons from '@ant-design/icons';

// ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //

// Fungsi rekursif untuk memetakan nama icon (string) ke komponen icon dari @ant-design/icons
const mapIcons = (menuArray) => {
  return menuArray.map((item) => {
    const mappedItem = { ...item };
    // Berikan default icon (QuestionOutlined) jika icon kosong di database
    if (mappedItem.icon && typeof mappedItem.icon === 'string') {
      mappedItem.icon = icons[mappedItem.icon] || icons['QuestionOutlined'];
    } else {
      mappedItem.icon = icons['QuestionOutlined'];
    }
    if (mappedItem.children) {
      mappedItem.children = mapIcons(mappedItem.children);
    }
    return mappedItem;
  });
};

export default function Navigation() {
  const [menuItems, setMenuItems] = useState({ items: [] });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMenu = async () => {
      try {
        let processedMenu = [];

        // Tambahkan Menu Edukasi / Absensi
        processedMenu.push({
          id: 'group-edukasi',
          title: 'Sistem Absensi',
          type: 'group',
          children: [
            {
              id: 'absensi-siswa',
              title: 'Daftar Siswa',
              type: 'item',
              url: '/absensi/siswa',
              icon: icons['TeamOutlined'] || icons['QuestionOutlined']
            },
            {
              id: 'absensi-riwayat',
              title: 'Riwayat Absensi',
              type: 'item',
              url: '/absensi/riwayat',
              icon: icons['HistoryOutlined'] || icons['QuestionOutlined']
            },
            {
              id: 'absensi-form',
              title: 'Input / Scan Absen',
              type: 'item',
              url: '/absensi/form',
              icon: icons['ScanOutlined'] || icons['QuestionOutlined']
            }
          ]
        });
        
        setMenuItems({ items: processedMenu });
      } catch (error) {
        console.error('Failed to set menu:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchMenu();
  }, []);

  if (loading) {
    return (
      <Box sx={{ p: 5, display: 'flex', justifyContent: 'center' }}>
        <CircularProgress size={24} />
      </Box>
    );
  }

  const navGroups = menuItems.items.map((item) => {
    switch (item.type) {
      case 'group':
        return <NavGroup key={item.id} item={item} />;
      default:
        return (
          <Typography key={item.id} variant="h6" sx={{ color: 'error.main', textAlign: 'center' }}>
            Fix - Navigation Group
          </Typography>
        );
    }
  });

  return <Box sx={{ pt: 2 }}>{navGroups}</Box>;
}
